<style scoped>
	div{box-sizing: border-box;}
	.template{ width: 100%;}
	.swiperD{width: 100%;}
	.swiper-slide{width: 100%;}
	.swiper-slide img{width: 100%;height: 10rem; position: relative;}
	.seTit{ position: absolute;bottom: 0;z-index: 99; background-color: rgba(255, 255, 255, 0.5);width: 100%;padding: 12px;text-align: center;font-size: 0.7rem;box-sizing: border-box;}
	.tit-1{ background-image: url(../../../../public/icon/001.png);background-size: cover;background-repeat: no-repeat;color: #fff;height: 2.5rem;line-height: 2.5rem; text-align: center;width: 10rem;}
	.anliList{ width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;}
	.anliListItem{ width: 50%;padding: 0.3rem;box-sizing: border-box;background-color: #f2f2f2;}
	.userInfo{ width: 100%;display: flex;flex-direction: row;background-color: #fff;padding: 0.5rem;}
	.usphoto{ width: 2rem;height: 2rem;border-radius: 50%;overflow: hidden;}
	.usname{ display: inline-flex;align-items: center;}
	.tuandui{ width: 100%;display: flex;flex-direction: row;flex-wrap: wrap;}
	.tuanduiItem{ width: 25%;padding: 0.5rem;}
	.tuanduiItem .userPotot{ width: 100%;}
	.tuanduiItem .userPotot img{width: 100%; border-radius: 50%;}
	.userName{ width: 100%;text-align: center;}
	.ne{ padding: 0.5rem;border-bottom: 1px solid #F2F2F2;}
	.seemoreDe{ padding: 15px;text-align: center;font-size: 0.8rem;;}

</style>
<template>
	<div class="template">
		<div class="swiperD">
			<div class="swiper-container swiper-ba" style="height: 10rem;">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="sw in swiperArr" @click="seeInfo(sw)">
						<img :src="imageUrl+sw.pic" />
						<div class="seTit">{{sw.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="desugnAnli">
			<div class="tit-1"> 设计案例</div>
			<div class="anliList">
				<div class="anliListItem" v-for="ai,index in anliArr" @click="seePhoto(ai)">
					<img :src="imgAPI+ai.imgUrlArr[0]" style="width: 100%;" />
					<div class="userInfo">
						<div class="usphoto" @click="usersWorks(ai)" style="">
							<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../../public/icon/001.jpg')" style="width: 100%;" />
						</div>
						<div class="usname">{{ai.nickname}}</div>
					</div>
				</div>
			</div>
			<div class="seemoreDe">
				<span v-if="pTotla>20" style="cursor: pointer;" @click="seeWorks_more">查看更多</span>
				<span v-if="pTotla<21">没有更多了</span>
			</div>
		</div>
		<div class="desugnAnli" style="margin-top: 2rem;">
			<div class="tit-1"> 设计师</div>
			<div class="tuandui">
				<div class="tuanduiItem" v-for="ai,index in des_team">
					<div class="userPotot" @click="usersWorks(ai)">
						<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../../public/icon/001.jpg')" />
					</div>
					<div class="userName">{{ai.nickname}}</div>
				</div>
			</div>
		</div>

		<div class="desugnAnli" style="margin-top: 2rem;">
			<div class="tit-1"> 设计机构</div>
			<div class="tuandui">
				<div class="tuanduiItem" v-for="ai,index in jigoudataList">
					<div class="userPotot" @click="usersWorks_jigou(ai)">
						<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../../public/icon/001.jpg')" />
					</div>
					<div class="userName">{{ai.nickname?ai.nickname:ai.name}}</div>
				</div>
			</div>
			<img v-if="jigoudataList.length<1" style="width: 100%;" src="../../../../public/img/74ebae016998d5fae28c89076ff97744.png" />
		</div>
		<div class="desugnAnli" style="margin-top: 2rem;">
			<div class="tit-1"> 专家团队</div>
			<div class="tuandui">
				<div class="tuanduiItem" v-for="ai,index in des_zj">
					<div class="userPotot" @click="usersWorks(ai)">
						<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../../public/icon/001.jpg')" />
					</div>
					<div class="userName">{{ai.name}}</div>
				</div>
			</div>
		</div>

		<div class="desugnAnli" style="margin-top: 2rem;">
			<div class="tit-1"> 新闻资讯</div>
			<div class="news">
				<div class="ne" v-for="ii in newsAndInformationArr" @click="seeInfo(ii,5)">{{ii.title}}</div>
			</div>
		</div>
		<div class="desugnAnli" style="margin-top: 2rem;">
			<div class="tit-1"> 概念孵化</div>
			<div class="news">
				<div class="ne" v-for="ii in newsAndInformationArr" @click="seeInfo(ii,1)">{{ii.title}}</div>
			</div>
		</div>

		<el-dialog title="" :show-close="false" :visible.sync="seePhotoDlog" class="myDlog myDlog_opa" :fullscreen="true">
			<worksInfoDlog :pageParams="pageParams" v-on:parentMethod="communication" v-if="seePhotoDlog"></worksInfoDlog>
		</el-dialog>
	</div>
</template>

<script>
	import "../../../assets/js/swiper.min.js"
	import baseConst from '../../../assets/js/baseConst.js' //注意路
	const worksInfoDlog = () =>
		import("@/components/mobile/two/anliInfo.vue"); //作品详情
	export default {
		components: {
			worksInfoDlog
		},
		data() {
			return {
				imageUrl:'http://www.1522znsj.com',
				swiper_ba: null,
				imgAPI: '',
				swiperArr: [],
				anliArr: [],
				des_team: [],
				des_zj: [],
				newsAndInformationArr: [],
				seePhotoDlog: false, //作品详情
				jigoudataList: [],
				pTotla: 0
			}
		},
		created: function() {
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			_this.getSwiperData_api();
			_this.getDesignLise();
			_this.getDesign_team();
			_this.getDesign_teamByZJ();
			_this.getIndustryInformation_api();
			_this.getDesignJigou();
		},
		mounted: function() {
			let _this = this;
		},
		methods: {
			/**  * -----查看图片
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seePhoto(obj) {
				let _this = this;
				_this.pageParams = JSON.parse(JSON.stringify(obj));
				_this.seePhotoDlog = true;
				//				setTimeout(function() {
				//					document.getElementsByClassName("el-dialog__body")[0].scrollTop = 0;
				//				}, 100)
			},
			/**  * -----初始化swiper    
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			initSwiper1() {
				let _this = this;
				_this.swiper_ba = new Swiper('.swiper-ba', {
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: true,
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
				});
			},
			/*获取轮播图片
			 创建于2019-11-22  作者：郑凯*/
			getSwiperData_api() {
				let _this = this;
				let paramsObj = this.$qs.stringify({});
				_this.$axios({
					method: 'get',
					url: '/api/indexData',
					headers: {},
					data: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.swiperArr = resObj.data;
						setTimeout(function() {
							_this.$nextTick(function() {
								_this.initSwiper1();
							})
						}, 1200)
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let params = {
					limit: 20,
					pageNumber: 1
				};
				_this.getApi('/api/getDesignWorksList', params)
					.then((res) => {
						console.log(res)
						if(res.status == '00') {
							_this.anliArr = res.data.data;
							_this.pTotla = res.data.total;
							for(let i = 0; i < _this.anliArr.length; i++) {
								let imgUrlArr = [];
								imgUrlArr = _this.anliArr[i].works.split('|');
								_this.anliArr[i].imgUrlArr = imgUrlArr;
							}
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*获取设计团队
			 创建于2019-11-25  作者：郑凯*/
			getDesign_team() {
				let _this = this;
				let params = {
					limit: 20
				};
				_this.getApi('/api/getDesignGroupList', params)
					.then((res) => {
						console.log(res)
						if(res.status == '00') {
							_this.des_team = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*获取专家设计团队
			 创建于2019-11-25  作者：郑凯*/
			getDesign_teamByZJ() {
				let _this = this;
				let params = {
					limit: 20
				};
				_this.getApi('/api/getExperts', params)
					.then((res) => {
						console.log(JSON.stringify(res))
						if(res.status == '00') {
							_this.des_zj = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*获取底部行业资讯
			 创建于2019-11-25  作者：郑凯*/
			getIndustryInformation_api() {
				let _this = this;
				let paramsObj = {
					"pageNumber": 1,
					"limit5": 5,
					"class_id": 5
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentListByClassId',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.newsAndInformationArr = resObj.data.data;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			/*获取底部概念孵化
			 创建于2019-11-25  作者：郑凯*/
			getConceptIncubation_api() {
				let _this = this;
				let paramsObj = {
					"pageNumber": 1,
					"limit5": 5,
					"class_id": 1
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentListByClassId',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.conceptIncubationArr = resObj.data.data;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			/**  * -----查看详情
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seeInfo(obj, type) {
				let _this = this;
				if(type) {
					obj.type = type;
				}
				_this.$router.push({
					path: '/mnewInfo',
					query: {
						content_id: obj.content_id,
						type: obj.type
					}
				})
			},
			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_info':
						_this.seePhotoDlog = false;
						break;
					default:
				}
			},

			usersWorks(user) {
				let _this = this;
				_this.$router.push({
					path: '/muser_works',
					query: {
						user: JSON.stringify(user)
					}
				})
			},

			usersWorks_jigou(user) {
				let _this = this;
				_this.$router.push({
					path: '/muser_works_jigou',
					query: {
						user: JSON.stringify(user)
					}
				})
			},
			/*获取设计机构
			 创建于2019-11-25  作者：郑凯*/
			getDesignJigou() {
				let _this = this;
				let apiUrl = '/api/getDesignOrg';
				let params = {
					limit: 2000,
					pageNumber: 1
				};
				_this.getApi(apiUrl, params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.jigoudataList = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*查看多多案例
			 创建于2019-11-25  作者：郑凯*/
			seeWorks_more() {
				let _this = this;
				_this.$router.push('mworks_more');
			},
		}
	}
</script>